import * as React from 'react';
import '../../inCss/Card.css';
import { ESimProfiles } from '../../reducers/user';

export interface ListOptionsCardProps {
    listOptions: ESimProfiles[];
    btnElement: string;
    onChangeEvt: (eSimProfiles: ESimProfiles) => void;
    clickEvt: () => void;
    selectedEsimProfiles: ESimProfiles;
}

export const ListOptionsCard: React.StatelessComponent<ListOptionsCardProps> = (props) => {

    return (
        <div className="card">
            <div className="card-body">
                <p id="listPageTitle" className="card-title">Choose your profile</p>
                <p className="body-text" id="trbins">
                    We have detected multiple services on your device, please select the appropriate service to proceed. </p>
                <p>&nbsp;</p>
                <div className="table-responsive-lg">
                    <table id="tblUserOption" className="table-hover table-custom">
                        <thead>
                            <tr className="table-head">
                                <th>&nbsp;</th>
                                <th>Service Number</th>
                                <th>ICCID</th>
                                <th>Billing Account Number</th>
                                <th>Plan</th>
                                <th>Installation Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.listOptions.map((item: ESimProfiles, index: number) =>
                                <tr key={index} className="table-row" >
                                    <td>
                                        <input
                                            id={`radio-${index}`}
                                            className="radio-active"
                                            type="radio"
                                            name="iccid"
                                            checked={props.selectedEsimProfiles === item}
                                            onClick={() => {
                                                props.onChangeEvt(item);
                                            }}
                                        />
                                    </td>
                                    <td>
                                        {item.esimServiceNumber}
                                    </td>
                                    <td>
                                        {item.iccid}
                                    </td>
                                    <td className="center-td">
                                        {item.billingAccountNumber}
                                    </td>
                                    <td>
                                        {item.dataPlan}
                                    </td>
                                    <td>
                                        {(item.isInstalled) ? <img src="./img/notins.png" /> : <span>Installed in Device</span>}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <button id="next_btn" className="button-primary btn-text" onClick={props.clickEvt}>
                    {props.btnElement}
                </button>
            </div>
        </div>
    );
};

export default ListOptionsCard;



// WEBPACK FOOTER //
// ./src/components/cards/ListOptionsCard.tsx